import {getFormValues} from 'redux-form';

import type {NutshellState} from '../../../store';

type Field = {
    name: string;
    value: string;
};

export const peepFormSelector = (state: NutshellState, formKey: string): Field[] => {
    const formValues = getFormValues(formKey)(state);
    const fields = [
        {
            name: 'name',
            // @ts-expect-error
            value: formValues.name,
        },
        {
            name: 'email',
            // @ts-expect-error
            value: formValues.emails[0].value,
        },
        {
            name: 'phone',
            // @ts-expect-error
            value: formValues.phones[0].value,
        },
    ];

    return fields;
};

export const getPeepUrl = (id: string, entityType: string): string => {
    if (entityType === 'contacts') {
        return `/person/${id}`;
    } else {
        return `/company/${id}`;
    }
};

const MIN_SEARCH_LENGTH = 3;
export const shouldShowDuplicateEntities = (parsedFields: Field[]): boolean => {
    return parsedFields.some((field) => field.value && field.value.length >= MIN_SEARCH_LENGTH);
};
